var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "次品组" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.group_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "group_name", $$v)
                                    },
                                    expression: "form.group_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "城市" },
                                model: {
                                  value: _vm.form.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "city", $$v)
                                  },
                                  expression: "form.city"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: "0", label: "全部" }
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.citys, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "状态" },
                                model: {
                                  value: _vm.form.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "status", $$v)
                                  },
                                  expression: "form.status"
                                }
                              },
                              [
                                _c("el-option", {
                                  key: "",
                                  attrs: { value: "", label: "全部" }
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.isUse, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v(
                    "\n      数据汇总:    次品组" +
                      _vm._s(_vm.resData.total) +
                      "组\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.addPg }
                  },
                  [_vm._v("+创建次品组")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "800",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "dgid",
                            label: "次品组id"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "group_name",
                            label: "次品组"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "defective_group_city",
                            label: "城市"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "supply_num",
                            label: "绑定商家数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "member_num",
                            label: "次品员数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "defective_group_status",
                            label: "状态"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "创建时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            width: "180"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editDg(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("\n                编辑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.PgLog(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("\n                查看日志")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1059297991
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: { title: "操作日志", visible: _vm.logVisible },
                    on: {
                      "update:visible": function($event) {
                        _vm.logVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-table",
                      { attrs: { data: _vm.logData } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            property: "action_type",
                            label: "事件",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "内容", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(scope.row.action_desc)
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            property: "action_admin",
                            label: "操作人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            property: "create_time",
                            label: "操作时间",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "添加/编辑次品组",
                      width: "20%",
                      visible: _vm.editVisible,
                      "before-close": _vm.closeEditDefective
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.editVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          model: _vm.defective_form,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "次品组名称",
                              required: "",
                              "hide-required-asterisk": true
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              model: {
                                value: _vm.defective_form.group_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.defective_form,
                                    "group_name",
                                    $$v
                                  )
                                },
                                expression: "defective_form.group_name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "绑定城市", required: "" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "城市" },
                                model: {
                                  value: _vm.defective_form.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.defective_form, "city", $$v)
                                  },
                                  expression: "defective_form.city"
                                }
                              },
                              _vm._l(_vm.citys, function(item) {
                                return item.value > 0
                                  ? _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  : _vm._e()
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态", required: "" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "状态" },
                                model: {
                                  value: _vm.defective_form.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.defective_form, "status", $$v)
                                  },
                                  expression: "defective_form.status"
                                }
                              },
                              _vm._l(_vm.isUse, function(item) {
                                return item.value > 0
                                  ? _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  : _vm._e()
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.closeEditDefective }
                          },
                          [_vm._v("\n              取 消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.saveDefective }
                          },
                          [_vm._v("\n              确 定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.resData.page,
                        background: "",
                        layout: "total, prev, sizes, pager, next, jumper ",
                        total: _vm.resData.total,
                        "page-size": 50,
                        "page-sizes": [10, 50, 100]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.resData, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.resData, "page", $event)
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3d6d568", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3d6d568","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/defectivegroup/group.vue
// module id = null
// module chunks = 